import { Suspense, useEffect, useState, useCallback, useMemo } from "react";
import { AiOutlineDownload, AiOutlineWarning } from "react-icons/ai";
import { Select, Tag } from "antd";
import { Tooltip } from "react-tooltip";
import { toast } from "react-toastify";
import axiosInstance from "../../../../services/axios-client";
import Loading from "../../../../components/loading/Loading";
import EmptyProject from "../../summaryCurrentProject/EmptyProject";
import PaginationComponent from "../../../../components/pagination/PaginationComponent";
import JustificationModalLatest from "../justificationComponent/JustificationModalLatest";
import TopRemark from "../justificationComponent/TopRemark";
import DefaultRemark from "../justificationComponent/DefaultRemark";
import BottomRemark from "../justificationComponent/BottomRemark";
import TableHeaderCell from "./table/TableHeaderCell";
import ExcelFilter from "./ExcelFilter";
import TableRow from "./table/TableRow";
import { formatScore } from "./table/tableHelpers";
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient";
import { useAuth } from "../../../../hooks/useAuth";

const RATING_OPTIONS = [
  { label: '-', value: '' },
  { label: 'A+', value: 'A+' },
  { label: 'A', value: 'A' },
  { label: 'B+', value: 'B+' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' }
];

const CHANGE_SCORE_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'CHANGED', value: 'changed' },
  { label: 'UNCHANGED', value: 'unchanged' },
  { label: '+1 Rating', value: 1 },
  { label: '+2 Rating', value: 2 },
  { label: '-1 Rating', value: -1 },
  { label: '-2 Rating', value: -2 }
];

// const COLUMN_OPTIONS = [
//   { label: 'All', value: 'all' },
//   { label: 'Employee', value: 'Employee' },
//   { label: 'Grade', value: 'Grade' },
//   { label: 'Supervisor', value: 'Supervisor' },
//   { label: 'Division', value: 'Division' },
//   { label: 'Prev. Rating', value: 'Prev. Rating' },
//   { label: 'Actual', value: 'Actual' },
//   { label: 'Calibration (Previous)', value: 'Calibration (Previous)' },
//   { label: 'Calibration', value: 'Calibration' },
//   { label: 'Status', value: 'Status' },
//   { label: 'Justification', value: 'Justification' }
// ];

// Generate score options from 0 to 5 with 0.1 step for quick selection
const SCORE_OPTIONS = [];
for (let i = 0; i <= 50; i++) {
  const value = (i * 0.1).toFixed(1);
  SCORE_OPTIONS.push({ label: value, value: parseFloat(value) });
}

const CalibrationTableRefactored = (props) => {
  const {
    calibratedUsers,
    calibratedScore,
    setCalibratedScore,
    onChangeHandler,
    automaticallyChangeRating,
    onSavingScoreChange,
    projectPhase,
    watch,
    show,
    handleClose,
    handleShow,
    project,
    justificationIdNotFilled,
    phaseOption,
    params,
    excelLink,
    userNameOption,
    gradeOption,
    supervisorNameOption,
    divisionOption,
    calibratorID,
    page,
    totalPage,
    changePage,
    setPage,
    getUserCurrentProject,
    postChangeRatingScore,
    checkTopBottomRemark,
    ratingState
  } = props;

  // Get current user for role checking
  const { getCurrentRealUserRole } = useAuth();
  // const currentUser = getCurrentUser();

  // State
  const [justificationModalUserID, setJustificationModalUserID] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);
  const [previousRating, setPreviousRating] = useState("Y1Rating");
  const [yearOptions, setYearOptions] = useState([]);
  const [latestCalibration, setLatestCalibration] = useState(-2);
  const [spmoComment, setSpmoComment] = useState();
  const [detailActualScore, setDetailActualScore] = useState({
    PTTScore: 0,
    PATScore: 0,
    Score360: 0
  });
  const [userJustification, setUserJustification] = useState();
  const [showJustification, setShowJustification] = useState(false);
  const [phaseBefore, setPhaseBefore] = useState();
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState(null);
  const [isSavingScore, setIsSavingScore] = useState(false);
  const [currentEditingUserId, setCurrentEditingUserId] = useState(null);
  const [lastSavedValues, setLastSavedValues] = useState({});
  const [bulkJustificationFile, setBulkJustificationFile] = useState(null);
  const [isUploadingJustification, setIsUploadingJustification] = useState(false);
  const [filterJustification, setFilterJustification] = useState({
    withAdditionalInfo: "",
    withJustification: "",
    withJustificationNotFilled: ""
  });
  const [selectedJustificationFilter, setSelectedJustificationFilter] = useState('all');

  // Filter states
  const [filterRatingBefore, setFilterRatingBefore] = useState("");
  const [filterRating, setFilterRating] = useState("");
  const [filterActualRating, setFilterActualRating] = useState("");
  const [filterUserName, setFilterUserName] = useState([]);
  const [filterGrade, setFilterGrade] = useState([]);
  const [filterSupervisorName, setFilterSupervisorName] = useState([]);
  const [filterDivision, setFilterDivision] = useState([]);
  const [filterChangeScore, setFilterChangeScore] = useState('all');
  const [filterColumn, setFilterColumn] = useState([
    'Employee', 'Grade', 'Supervisor', 'Division', 'Prev. Rating',
    'Actual', 'Calibration (Previous)', 'Calibration', 'Status', 'Justification'
  ]);

  // Auto-detect if division data exists
  const hasDivisionData = useMemo(() => {
    return divisionOption && divisionOption.length > 0;
  }, [divisionOption]);

  // Auto-update filterColumn when division data availability changes
  useEffect(() => {
    const baseColumns = [
      'Employee', 'Grade', 'Supervisor', 'Prev. Rating',
      'Actual', 'Calibration (Previous)', 'Calibration', 'Status', 'Justification'
    ];
    
    const columnsWithDivision = [
      'Employee', 'Grade', 'Supervisor', 'Division', 'Prev. Rating',
      'Actual', 'Calibration (Previous)', 'Calibration', 'Status', 'Justification'
    ];

    setFilterColumn(hasDivisionData ? columnsWithDivision : baseColumns);
  }, [hasDivisionData]);

  // Dynamic column options based on division data availability
  const dynamicColumnOptions = useMemo(() => {
    return [
      { label: 'Employee', value: 'Employee' },
      { label: 'Grade', value: 'Grade' },
      { label: 'Supervisor', value: 'Supervisor' },
      { label: 'Division', value: 'Division' },
      { label: 'Prev. Rating', value: 'Prev. Rating' },
      { label: 'Actual', value: 'Actual' },
      { label: 'Calibration (Previous)', value: 'Calibration (Previous)' },
      { label: 'Calibration', value: 'Calibration' },
      { label: 'Status', value: 'Status' },
      { label: 'Justification', value: 'Justification' }
    ];
  }, []);

  // Sort states
  const [sortName, setSortName] = useState("default");
  const [sortGrade, setSortGrade] = useState("default");
  const [sortActualScore, setSortActualScore] = useState("default");
  const [sortActualRating, setSortActualRating] = useState("default");
  const [sortScoreLatestMinusOne, setSortScoreLatestMinusOne] = useState("default");
  const [sortRatingLatestMinusOne, setSortRatingLatestMinusOne] = useState("default");
  const [sortScoreLatest, setSortScoreLatest] = useState("default");
  const [sortRatingLatest, setSortRatingLatest] = useState("default");

  // Year options effect
  useEffect(() => {
    if (project) {
      setYearOptions([
        { label: project.Year - 1, value: "Y1" },
        { label: project.Year - 2, value: "Y2" }
      ]);
    }
  }, [project]);

  useEffect(() => {
    const uploadFlag = localStorage.getItem("bulkJustificationUploadSuccess");
    if (uploadFlag === "true") {
      localStorage.removeItem("bulkJustificationUploadSuccess");
      toast.success("Bulk justification uploaded successfully!", {
        autoClose: 3000
      });
    }
  }, []);

  // Fetch data effect
  useEffect(() => {
    if (calibratorID && params) {
      getUserCurrentProject(
        calibratorID, params.prev_calibrator, params.bu_performance,
        params.type, params.rating, params.project_id, page,
        filterUserName, filterGrade, filterSupervisorName, filterDivision,
        sortName, sortGrade, sortActualScore, sortActualRating,
        sortScoreLatest, sortRatingLatest,
        filterRating, latestCalibration + 1, sortScoreLatestMinusOne,
        sortRatingLatestMinusOne, filterRatingBefore, filterChangeScore, filterActualRating, filterJustification.withAdditionalInfo
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    calibratorID, page, filterUserName, filterGrade, filterSupervisorName, filterDivision,
    sortName, sortGrade, sortActualScore, sortActualRating,
    sortScoreLatest, sortRatingLatest,
    filterRating, latestCalibration, sortScoreLatestMinusOne,
    sortRatingLatestMinusOne, filterRatingBefore, filterChangeScore, filterActualRating, filterJustification
  ]);

  // Handlers
  const toggleSort = useCallback((currentState, setState) => {
    const nextState = {
      default: "ascending",
      ascending: "descending",
      descending: "default"
    };
    setState(nextState[currentState] || "default");
  }, []);

  const downloadExcel = useCallback(async () => {
    try {
      setIsDownloadingReport(true);
      const response = await axiosInstance.get(excelLink, {
        responseType: 'arraybuffer'
      });
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report.xlsx';
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      toast.error(
        error.response?.data?.status?.description ||
        error.message ||
        "Failed to download file",
        {
          autoClose: 3000
        }
      );
    } finally {
      setIsDownloadingReport(false);
    }
  }, [excelLink]);

  const handleJustificationFilterChange = useCallback((value) => {
    setSelectedJustificationFilter(value);
    
    if (value === 'withAdditionalInfo') {
      setFilterJustification({
        withAdditionalInfo: true,
        withJustification: '',
        withJustificationNotFilled: ''
      });
    } else if (value === 'withJustification') {
      setFilterJustification({
        withAdditionalInfo: '',
        withJustification: true,
        withJustificationNotFilled: ''
      });
    } else if (value === 'withJustificationNotFilled') {
      setFilterJustification({
        withAdditionalInfo: '',
        withJustification: '',
        withJustificationNotFilled: true
      });
    } else if (value === 'withoutAdditionalInfo') {
      setFilterJustification({
        withAdditionalInfo: false,
        withJustification: '',
        withJustificationNotFilled: ''
      });
    } else {
      // Reset all filters for 'all' or any other value
      setFilterJustification({
        withAdditionalInfo: '',
        withJustification: '',
        withJustificationNotFilled: ''
      });
    }
  }, []);

  const handleShowJustificationModal = useCallback((user, isViewMode) => {
    const calibrationData = user.CalibrationScores.filter(obj => obj.ProjectPhaseID);
    
    if (isViewMode) {
      setJustificationModalUserID(user.ID);
      setUserJustification({
        Nik: user.Nik,
        Name: user.Name,
        Designation: user.Position
      });
      setShowJustification(true);
    } else {
      setJustificationModalUserID(user.ID);
      setSelectedUser({
        Nik: user.Nik,
        Name: user.Name,
        Designation: user.Position,
        EmployeeID: user.ID,
        ProjectID: project.ID,
        ProjectPhaseID: projectPhase.ID,
        FirstComment: calibrationData[0]?.Comment
      });
      handleShow();
      
      if (calibrationData.length > 1) {
        setPhaseBefore(calibrationData[calibrationData.length - 2].ProjectPhaseID);
      } else {
        setPhaseBefore();
      }
    }
  }, [project, projectPhase, handleShow]);

  const handleShowAdditionalInfoModal = useCallback((user) => {
    if (user.AdditionalInfo) {
      setSelectedAdditionalInfo({
        name: user.Name,
        nik: user.Nik,
        position: user.Position,
        supervisor: user.SupervisorNames,
        info: user.AdditionalInfo
      });
      setShowAdditionalInfo(true);
    }
  }, []);

  const handleRatingChange = useCallback(async (rating, user) => {
    const flagError = await onChangeHandler(rating, user.ID, calibratorID, params);
    
    if (flagError === "error") return;

    const calibrationData = user.CalibrationScores.filter(obj => obj.ProjectPhaseID);
    
    // Check if justification is required
    const newPayload = { ...calibratedScore };
    const justificationType = checkTopBottomRemark(
      newPayload[user.ID].ActualRating,
      rating
    );
    
    // Set modal data
    setJustificationModalUserID(user.ID);
    setSelectedUser({
      Nik: user.Nik,
      Name: user.Name,
      Designation: user.Position,
      EmployeeID: user.ID,
      ProjectID: project.ID,
      ProjectPhaseID: projectPhase.ID,
      FirstComment: calibrationData[0]?.Comment
    });

    if (calibrationData.length > 1) {
      setPhaseBefore(calibrationData[calibrationData.length - 2].ProjectPhaseID);
    } else {
      setPhaseBefore();
    }

    // Automatically open modal for justification or general comment
    if (justificationType === "maximum") {
      // Prevent changes that exceed maximum level
      toast.error(`Rating changes cannot exceed maximum level for ${user.Name}`, {
        autoClose: 3000,
        toastId: `maximum-exceeded-${user.ID}`
      });
      
      // Revert the rating back to the last successfully saved rating
      const revertedPayload = { ...calibratedScore };
      revertedPayload[user.ID].CalibrationRating = revertedPayload[user.ID].CalibrationRatingSaved;
      
      // Check what justification type the reverted rating requires
      const revertedJustificationType = checkTopBottomRemark(
        revertedPayload[user.ID].ActualRating,
        revertedPayload[user.ID].CalibrationRatingSaved
      );
      
      revertedPayload[user.ID].JustificationType = revertedJustificationType;
      revertedPayload[user.ID].FilledTopBottomMark = revertedJustificationType === "default" ? true : revertedPayload[user.ID].FilledTopBottomMark;
      setCalibratedScore(revertedPayload);
      
      // Call API to revert the change
      await postChangeRatingScore({
        EmployeeID: user.ID,
        ProjectPhaseID: revertedPayload[user.ID].ProjectPhaseID,
        ProjectID: project.ID,
        CalibratorID: calibratorID,
        CalibrationScore: revertedPayload[user.ID].CalibrationScore,
        CalibrationRating: revertedPayload[user.ID].CalibrationRatingSaved,
        JustificationType: revertedJustificationType,
        FilledTopBottomMark: revertedJustificationType === "default" ? true : revertedPayload[user.ID].FilledTopBottomMark
      });
    } else if (justificationType !== "default") {
      toast.info(`Please fill justification remark for ${user.Name}`, {
        autoClose: 3000,
        toastId: `justification-required-${user.ID}`
      });
      handleShow();
      // Update CalibrationRatingSaved to current rating since it's a successful change
      const updatedPayload = { ...calibratedScore };
      updatedPayload[user.ID].CalibrationRatingSaved = rating;
        setCalibratedScore(newPayload);
    } else {
      // Update CalibrationRatingSaved to current rating since it's a successful change
      const updatedPayload = { ...calibratedScore };
      updatedPayload[user.ID].CalibrationRatingSaved = rating;
      setCalibratedScore(updatedPayload);
      
      // Show general comment modal for default justification type only if rating actually changed
      const beforeRating = newPayload[user.ID].ActualRating;
      const afterRating = rating;
      
      // Only show modal if rating level has changed
      if (ratingState && ratingState[afterRating] !== ratingState[beforeRating]) {
        toast.info(`You can add general comment for ${user.Name}`, {
          autoClose: 3000,
          toastId: `general-comment-${user.ID}`
        });
        handleShow();
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChangeHandler, calibratorID, params, calibratedScore, project, projectPhase, checkTopBottomRemark, handleShow, ratingState]);

  // Save score changes (called on blur or Enter)
  const saveScoreChange = useCallback(async (user, showModal = false) => {
    const id = user.ID;
    const newPayload = { ...calibratedScore };
    
    // Check if this exact value was already saved to prevent duplicate API calls
    const currentValue = `${newPayload[id]?.CalibrationScore}-${newPayload[id]?.CalibrationRating}`;
    
    if (lastSavedValues[id] === currentValue) {
      return;
    }
    
    // Check if ANY save is already in progress (regardless of user)
    if (isSavingScore) {
      return;
    }
    
    // Set saving state to disable other inputs
    setIsSavingScore(true);
    setCurrentEditingUserId(id);
    
    // Notify parent component
    if (onSavingScoreChange) {
      onSavingScoreChange(true);
    }
    
    const justificationType = checkTopBottomRemark(
      newPayload[id].ActualRating,
      newPayload[id].CalibrationRating
    );

    let valueFilled = newPayload[id].FilledTopBottomMark;
    if (newPayload[id].CalibrationRating === newPayload[id].CurrentSavedRating) {
      valueFilled = newPayload[id].FilledTopBottomMark;
    }

    const statusData = await postChangeRatingScore({
      EmployeeID: id,
      ProjectPhaseID: newPayload[id].ProjectPhaseID,
      ProjectID: newPayload[id].ProjectID,
      CalibratorID: newPayload[id].CalibratorID,
      CalibrationScore: newPayload[id].CalibrationScore,
      CalibrationRating: newPayload[id].CalibrationRating,
      JustificationType: justificationType,
      FilledTopBottomMark: valueFilled
    });

    // Use API response data instead of local calculation
    if (statusData?.data?.data) {
      newPayload[id].JustificationType = statusData.data.data.JustificationType || justificationType;
      newPayload[id].FilledTopBottomMark = statusData.data.data.FilledTopBottomMark;
    } else {
      // Fallback to original logic if no response
      newPayload[id].JustificationType = justificationType;
      newPayload[id].FilledTopBottomMark = valueFilled;
    }
    setCalibratedScore(newPayload);

    // Show modal if explicitly requested (on blur)
    if (statusData && showModal) {
      // Set modal data for the user
      const calibrationData = user.CalibrationScores?.filter(obj => obj.ProjectPhaseID) || [];
      setJustificationModalUserID(id);
      setSelectedUser({
        Nik: user.Nik,
        Name: user.Name,
        Designation: user.Position,
        EmployeeID: id,
        ProjectID: newPayload[id].ProjectID,
        ProjectPhaseID: newPayload[id].ProjectPhaseID,
        FirstComment: calibrationData[0]?.Comment
      });

      if (calibrationData.length > 1) {
        setPhaseBefore(calibrationData[calibrationData.length - 2].ProjectPhaseID);
      } else {
        setPhaseBefore();
      }

      // Show appropriate message based on justification type
      if (justificationType === "maximum") {
        // Prevent changes that exceed maximum level
        toast.error(`Rating changes cannot exceed maximum level for ${user.Name}`, {
          autoClose: 3000,
          toastId: `maximum-exceeded-${user.ID}`
        });
        
        // Revert the rating and score back to original
        newPayload[id].CalibrationRating = newPayload[id].CalibrationRatingSaved;
        newPayload[id].CalibrationScore = newPayload[id].CalibrationScoreSaved;
        
        // Check what justification type the reverted rating requires
        const revertedJustificationType = checkTopBottomRemark(
          newPayload[id].ActualRating,
          newPayload[id].CalibrationRatingSaved
        );
        
        newPayload[id].JustificationType = revertedJustificationType;
        newPayload[id].FilledTopBottomMark = revertedJustificationType === "default" ? true : newPayload[id].FilledTopBottomMark;
        setCalibratedScore(newPayload);
        
        // Call API to revert the change
        await postChangeRatingScore({
          EmployeeID: id,
          ProjectPhaseID: newPayload[id].ProjectPhaseID,
          ProjectID: newPayload[id].ProjectID,
          CalibratorID: newPayload[id].CalibratorID,
          CalibrationScore: newPayload[id].CalibrationScoreSaved,
          CalibrationRating: newPayload[id].CalibrationRatingSaved,
          JustificationType: revertedJustificationType,
          FilledTopBottomMark: revertedJustificationType === "default" ? true : newPayload[id].FilledTopBottomMark
        });
      } else if (justificationType !== "default") {
        toast.info(`Please fill justification remark for ${user.Name}`, {
          autoClose: 3000,
          toastId: `justification-required-${user.ID}`
        });
        handleShow();
        // Update CalibrationRatingSaved and CalibrationScoreSaved since it's a successful change
        newPayload[id].CalibrationRatingSaved = newPayload[id].CalibrationRating;
        newPayload[id].CalibrationScoreSaved = newPayload[id].CalibrationScore;
        setCalibratedScore(newPayload);
      } else {
        // Update CalibrationRatingSaved and CalibrationScoreSaved since it's a successful change
        newPayload[id].CalibrationRatingSaved = newPayload[id].CalibrationRating;
        newPayload[id].CalibrationScoreSaved = newPayload[id].CalibrationScore;
        setCalibratedScore(newPayload);
        
        // Only show modal for default type if rating actually changed
        const beforeRating = newPayload[id].ActualRating;
        const afterRating = newPayload[id].CalibrationRating;
        
        if (ratingState && ratingState[afterRating] !== ratingState[beforeRating]) {
          toast.info(`You can add general comment for ${user.Name}`, {
            autoClose: 3000,
            toastId: `general-comment-${user.ID}`
          });
          handleShow();
        }
      }
    }
    
    // Update last saved values to prevent duplicate saves
    const savedValueString = `${newPayload[id].CalibrationScore}-${newPayload[id].CalibrationRating}`;
    setLastSavedValues(prev => ({
      ...prev,
      [id]: savedValueString
    }));
    
    // Refresh total calibrated score and average score to update display
    if (props.getTotalCalibratedScore && calibratorID && params) {
      props.getTotalCalibratedScore(
        calibratorID, 
        params.prev_calibrator || "", 
        params.bu_performance, 
        params.type, 
        params.project_id
      );
    }
    
    if (props.getAverageScore && calibratorID && params) {
      props.getAverageScore(
        calibratorID, 
        params.prev_calibrator || "", 
        params.bu_performance, 
        params.type, 
        params.project_id
      );
    }
    
    // Clear saving state after everything is complete
    setIsSavingScore(false);
    setCurrentEditingUserId(null);
    
    // Notify parent component
    if (onSavingScoreChange) {
      onSavingScoreChange(false);
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [calibratedScore, checkTopBottomRemark, postChangeRatingScore, setCalibratedScore, handleShow, lastSavedValues, isSavingScore, currentEditingUserId, ratingState, props.getTotalCalibratedScore, props.getAverageScore, calibratorID, params]);

  const handleScoreSelectChange = useCallback(async (value, user) => {
    let score = value;
    
    // If user typed a custom value, validate and parse it
    if (typeof value === 'string') {
      const parsedScore = parseFloat(value);
      if (isNaN(parsedScore) || parsedScore < 0 || parsedScore > 5) {
        toast.error("Score must be between 0 and 5");
        return;
      }
      // Round to 2 decimal places to handle precision issues
      score = Math.round(parsedScore * 100) / 100;
    }

    // Create a fake event object to maintain compatibility with existing automaticallyChangeRating function
    const fakeEvent = {
      target: {
        name: user.ID,
        value: score
      }
    };

    // Update local state immediately for responsive UI
    automaticallyChangeRating(fakeEvent, calibratorID, params);

    // Save changes and check if justification is required
    await saveScoreChange(user, true); // Show modal if needed
  }, [automaticallyChangeRating, calibratorID, params, saveScoreChange]);

  // Handle input change for number input (real-time updates)
  const handleScoreInputChange = useCallback((e, user) => {
    let value = e.target.value;
    
    // Allow empty value during typing
    if (value === '') {
      const fakeEvent = {
        target: {
          name: user.ID,
          value: ''
        }
      };
      automaticallyChangeRating(fakeEvent, calibratorID, params);
      return;
    }
    
    // Basic validation - only allow numbers and one decimal point
    if (!/^[0-9]*\.?[0-9]*$/.test(value)) {
      return; // Don't update if invalid format
    }
    
    // Parse the value
    const numValue = parseFloat(value);
    
    // Create a fake event object to maintain compatibility with existing automaticallyChangeRating function
    const fakeEvent = {
      target: {
        name: user.ID,
        value: isNaN(numValue) ? 0 : numValue
      }
    };

    // Update local state immediately for responsive UI - no validation limit here to allow typing
    automaticallyChangeRating(fakeEvent, calibratorID, params);
  }, [automaticallyChangeRating, calibratorID, params]);

  // Handle blur - validate and save when user finishes input
  const handleScoreInputBlur = useCallback(async (e, user) => {
    const value = e.target.value;
    
    // Validate the input
    if (value === '') {
      toast.error("Score cannot be empty");
      e.target.focus();
      return;
    }
    
    const parsedScore = parseFloat(value);
    if (isNaN(parsedScore) || parsedScore < 0 || parsedScore > 5) {
      toast.error("Score must be between 0.00 and 5.00");
      e.target.focus();
      return;
    }
    
    // Round to 2 decimal places
    const roundedScore = Math.round(parsedScore * 100) / 100;
    
    // Update the input value to show the rounded score
    e.target.value = roundedScore.toFixed(2);
    
    // Create a fake event object with the validated score
    const fakeEvent = {
      target: {
        name: user.ID,
        value: roundedScore
      }
    };

    // Update local state with validated score
    automaticallyChangeRating(fakeEvent, calibratorID, params);

    // Save changes and check if justification is required (only on blur)
    await saveScoreChange(user, true);
  }, [automaticallyChangeRating, calibratorID, params, saveScoreChange]);

  // Watch for changes in calibratedScore and update visual indicators
  const usersRequiringJustification = useMemo(() => {
    if (!calibratedScore || Object.keys(calibratedScore).length === 0) return new Set();
    
    const newUsersRequiringJustification = new Set();
    
    Object.keys(calibratedScore).forEach(userId => {
      const userData = calibratedScore[userId];
      const justificationType = userData?.JustificationType;
      const isFilledTopBottomMark = userData?.FilledTopBottomMark;
      
      // Add to set if justification is required but not filled
      if (justificationType !== "default" && !isFilledTopBottomMark) {
        newUsersRequiringJustification.add(userId);
      }
    });
    
    return newUsersRequiringJustification;
  }, [calibratedScore]);

  const postBulkJustification = useCallback(async (file) => {
    const formData = new FormData();
    formData.append("excelFile", file);
    formData.append("projectID", project?.ID ?? "");
    formData.append("projectPhaseID", projectPhase?.ID ?? "");
    formData.append("calibratorID", calibratorID ?? "");

    try {
      setIsUploadingJustification(true);
      await axiosInstance.post("/auth/calibrations/upload-justification", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      localStorage.setItem("bulkJustificationUploadSuccess", "true");
    } catch (error) {
      toast.error(
        error.response?.data?.status?.description ||
          error.message ||
          "Failed to upload file",
        {
          autoClose: 3000
        }
      );
      throw error;
    } finally {
      setIsUploadingJustification(false);
    }
  }, [calibratorID, project, projectPhase]);

  // handle file change for bulk justification upload
  const handleFileChange = useCallback(
    (e) => {
      const file = e.target.files[0];
      if (!file) return;

      // Validate file type
      const validTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel"
      ];
      if (!validTypes.includes(file.type)) {
        toast.error("Please upload a valid Excel file (.xlsx or .xls)", {
          autoClose: 3000
        });
        e.target.value = "";
        return;
      }

      setBulkJustificationFile(file);
    },
    []
  );

  const handleBulkJustificationSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!bulkJustificationFile) {
        toast.error("Please select an Excel file first", {
          autoClose: 3000
        });
        return;
      }

      try {
        await postBulkJustification(bulkJustificationFile);
        setBulkJustificationFile(null);
        window.location.reload();
      } finally {
        if (e.target?.reset) {
          e.target.reset();
        }
      }
    },
    [bulkJustificationFile, postBulkJustification]
  );

  // Handle blur - save when user leaves the input
  // const handleScoreBlur = useCallback(async (user) => {
  //   const id = user.ID;
    
  //   // Clear any pending timeout since we're saving immediately on blur
  //   if (window.scoreChangeTimeouts?.[id]) {
  //     clearTimeout(window.scoreChangeTimeouts[id]);
  //     delete window.scoreChangeTimeouts[id];
  //   }
    
  //   // Show modal only on blur event to avoid double modal
  //   await saveScoreChange(user, true);
  // }, [saveScoreChange]);

  // Callback to handle justification saved - just for logging, no data refresh needed
  // const handleJustificationSaved = useCallback(() => {
    // No need to refresh data - the justification modals already update calibratedScore state
    // and the hasJustification calculation uses both original data and current state
    // The folder icon will appear immediately due to local state updates
  // }, []);

  // Render helpers
  const renderJustificationModal = useMemo(() => {
    if (!calibratedUsers || !calibratedScore || !justificationModalUserID || !selectedUser) {
      return null;
    }

    const type = calibratedScore[justificationModalUserID]?.JustificationType;
    const modalComponents = {
      top: TopRemark,
      default: DefaultRemark,
      bottom: BottomRemark
    };

    const SelectedModal = modalComponents[type];
    if (!SelectedModal) return null;

    return (
      <SelectedModal
        show={show}
        handleClose={handleClose}
        calibratedScore={calibratedScore}
        setCalibratedScore={setCalibratedScore}
        id={justificationModalUserID}
        user={selectedUser}
        watch={watch}
        phaseBefore={phaseBefore}
        project={project}
      />
    );
  }, [calibratedUsers, calibratedScore, justificationModalUserID, selectedUser, show, handleClose, setCalibratedScore, watch, phaseBefore, project]);

  if (!calibratedUsers) {
    return (
      <Suspense fallback={<Loading />}>
        <EmptyProject />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<Loading />}>
      <div>
        <style>
          {`
            .spinner {
              border: 2px solid transparent;
              border-top: 2px solid #ffffff;
              border-radius: 50%;
              width: 12px;
              height: 12px;
              animation: spin 1s linear infinite;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div className="d-flex justify-content-between align-items-center">
          {/* Upload Justification */}
          {getCurrentRealUserRole().includes('superadmin') || getCurrentRealUserRole().includes('admin') || getCurrentRealUserRole().includes('spmo') ? 
            (
                <form className="d-flex" onSubmit={handleBulkJustificationSubmit}>
                    <input 
                        type="file" 
                        className="form-control" 
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xlsx,.xls"
                        style={{ height: 'fit-content' }}
                        onChange={handleFileChange} 
                    />
                    <div align="right" style={{ width: '225px' }}>
                        <ActionButtonGradient
                            type="submit"
                            variant="primary"
                        children={isUploadingJustification ? "Uploading..." : "Bulk Justification"}
                        disabled={isUploadingJustification}
                        />
                    </div>
                </form>
              ) : null}

          {/* Filter Controls */}
          <div align="right" className="mb-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: "14px" }}>Filter Rating:</span>
              <ExcelFilter
                options={CHANGE_SCORE_OPTIONS}
                selectedValues={filterChangeScore !== 'all' ? [filterChangeScore] : []}
                onApply={(values) => {
                  setFilterChangeScore(values.length > 0 ? values[0] : 'all');
                }}
                onSort={(direction) => {
                  // No sort functionality needed for filter rating
                  console.log('Sort filter rating:', direction);
                }}
                currentSortState="default"
                placeholder="Filter Rating"
                label="Filter Rating"
                singleSelect={true}
                showSort={false}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: "14px" }}>Manage Columns:</span>
              <ExcelFilter
                options={dynamicColumnOptions}
                selectedValues={filterColumn}
                onApply={(values) => {
                  setFilterColumn(values);
                }}
                onSort={(direction) => {
                  // No sort functionality needed for column management
                  console.log('Sort columns:', direction);
                }}
                currentSortState="default"
                placeholder="Manage Columns"
                label="Manage Columns"
                singleSelect={false}
                showSort={false}
              />
            </div>

            {/* Reset Filters Button */}
            <ActionButtonGradient
              onClick={() => {
                // Reset all filters to default values
                setFilterChangeScore('all');
                setFilterUserName([]);
                setFilterGrade([]);
                setFilterSupervisorName([]);
                setFilterSupervisorName([]);
                setFilterDivision([]);
                setFilterRating('');
                setFilterRatingBefore('');
                setFilterActualRating('');
                setPreviousRating('Y1Rating');
                setSortName('default');
                setSortGrade('default');
                setSortActualScore('default');
                setSortActualRating('default');
                setSortScoreLatest('default');
                setSortRatingLatest('default');
                setSortScoreLatestMinusOne('default');
                setSortRatingLatestMinusOne('default');
                setSelectedJustificationFilter('all');
                setFilterJustification({
                  withAdditionalInfo: '',
                  withJustification: '',
                  withJustificationNotFilled: ''
                });
                setPage(1);
              }}
              variant="primary"
              size="small"
              children={"Reset Filters"}
            />

            {!params.rating && (
              <>
                <ActionButtonGradient
                  onClick={downloadExcel}
                  variant="primary"
                  size="small"
                  children={isDownloadingReport ? (
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <div className="spinner" /> Downloading...
                    </div>
                  ) : (
                    <>
                      <AiOutlineDownload style={{ fontSize: '12px' }} /> Download Report
                    </>
                  )}
                  disabled={isDownloadingReport || isSavingScore}
                />
              </>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive" style={{ overflowX: 'auto' }}>
          <table className="table calibration-table mt-3" id="table-to-xls">
            <thead>
        {/* TODO: Change to user friendly layout */}
        {/* <div className="table-responsive" style={{ overflowX: 'auto', maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
          <table className="table calibration-table mt-3" id="table-to-xls">
            <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}> */}
              <tr>
                <th rowSpan={2} className="text-center">No</th>

                {filterColumn.includes('Employee') && (
                  <TableHeaderCell
                    label=""
                    rowSpan={2}
                    sortState={sortName}
                    onSort={() => toggleSort(sortName, setSortName)}
                    showSort={false}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <span>Employee</span>
                      <ExcelFilter
                        options={userNameOption}
                        selectedValues={filterUserName}
                        onApply={(values) => {
                          setFilterUserName(values);
                          setPage(1);
                        }}
                        onSort={(direction) => {
                          const nextState = direction === 'ascending' ? 'ascending' : 
                                           direction === 'descending' ? 'descending' : 'default';
                          setSortName(nextState);
                        }}
                        currentSortState={sortName}
                        placeholder="Filter"
                        label="Employee"
                      />
                    </div>
                  </TableHeaderCell>
                )}

                {filterColumn.includes('Grade') && (
                  <TableHeaderCell
                    label=""
                    rowSpan={2}
                    sortState={sortGrade}
                    onSort={() => toggleSort(sortGrade, setSortGrade)}
                    showSort={false}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <span>Grade</span>
                      <ExcelFilter
                        options={gradeOption}
                        selectedValues={filterGrade}
                        onApply={(values) => {
                          setFilterGrade(values);
                          setPage(1);
                        }}
                        onSort={(direction) => {
                          const nextState = direction === 'ascending' ? 'ascending' : 
                                           direction === 'descending' ? 'descending' : 'default';
                          setSortGrade(nextState);
                        }}
                        currentSortState={sortGrade}
                        placeholder="Filter"
                        label="Grade"
                      />
                    </div>
                  </TableHeaderCell>
                )}

                {filterColumn.includes('Supervisor') && (
                  <TableHeaderCell label="" rowSpan={2}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <span>Supervisor</span>
                      <ExcelFilter
                        options={supervisorNameOption}
                        selectedValues={filterSupervisorName}
                        onApply={(values) => {
                          setFilterSupervisorName(values);
                          setPage(1);
                        }}
                        onSort={(direction) => {
                          // Supervisor doesn't have sort functionality
                          console.log('Sort supervisor:', direction);
                        }}
                        currentSortState="default"
                        placeholder="Filter"
                        label="Supervisor"
                        showSort={false}
                      />
                    </div>
                  </TableHeaderCell>
                )}

                {filterColumn.includes('Division') && (
                  <TableHeaderCell label="" rowSpan={2}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <span>Division</span>
                      <ExcelFilter
                        options={divisionOption}
                        selectedValues={filterDivision}
                        onApply={(values) => {
                          setFilterDivision(values);
                          setPage(1);
                        }}
                        onSort={(direction) => {
                          // Division doesn't have sort functionality
                          console.log('Sort division:', direction);
                        }}
                        currentSortState="default"
                        placeholder="Filter"
                        label="Division"
                        showSort={false}
                      />
                    </div>
                  </TableHeaderCell>
                )}

                {filterColumn.includes('Prev. Rating') && (
                  <th rowSpan={2} className="text-center" style={{ width: "10px" }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <span>Prev. Rating</span>
                      </div>
                      <Select
                        className="mt-2"
                        style={{ width: "80px" }}
                        value={previousRating.replace("Rating", "")}
                        options={yearOptions}
                        onChange={(e) => setPreviousRating(e + "Rating")}
                        placeholder="Select Rating"
                        size="small"
                      />
                    </div>
                  </th>
                )}

                {filterColumn.includes('Actual') && (
                  <th colSpan={2} className="text-center">Actual</th>
                )}

                {filterColumn.includes('Calibration (Previous)') && projectPhase && projectPhase.Phase.Order >= 2 && (
                  <th colSpan={2} className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      Calibration Phase
                      <Select
                        className="ms-1"
                        defaultValue={-2}
                        options={phaseOption}
                        onChange={(e) => setLatestCalibration(e)}
                      />
                    </div>
                  </th>
                )}

                {filterColumn.includes('Calibration') && projectPhase && (
                  <th colSpan={2} className="text-center">
                    Calibration Phase {projectPhase.Phase.Order}
                  </th>
                )}

                {filterColumn.includes('Status') && (
                  <th rowSpan={2} className="text-center">Status</th>
                )}

                {filterColumn.includes('Justification') && (
                  <th rowSpan={2} className="text-center" style={{ minWidth: '100px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <span>Justification</span>
                      <ExcelFilter
                        options={[
                          { label: 'With Additional Info', value: 'withAdditionalInfo' },
                          { label: 'Without Additional Info', value: 'withoutAdditionalInfo' },
                        ]}
                        selectedValues={selectedJustificationFilter !== 'all' ? [selectedJustificationFilter] : []}
                        onApply={(values) => {
                          const value = values.length > 0 ? values[0] : 'all';
                          handleJustificationFilterChange(value);
                        }}
                        onSort={(direction) => {
                          console.log('Sort justification:', direction);
                        }}
                        currentSortState="default"
                        placeholder="Filter"
                        label="Justification"
                        singleSelect={true}
                        showSort={false}
                      />
                    </div>
                  </th>
                )}
              </tr>

              <tr>
                {filterColumn.includes('Actual') && (
                  <>
                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        <span>Score</span>
                        <ExcelFilter
                          options={[]} // No filter options for score
                          selectedValues={[]}
                          onApply={() => {}} // No filter functionality for score
                          onSort={(direction) => {
                            const nextState = direction === 'ascending' ? 'ascending' : 
                                             direction === 'descending' ? 'descending' : 'default';
                            setSortActualScore(nextState);
                          }}
                          currentSortState={sortActualScore}
                          placeholder="Sort"
                          label="Actual Score"
                          showSort={true}
                        />
                      </div>
                    </th>
                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        <span>Rating</span>
                        <ExcelFilter
                          options={RATING_OPTIONS.filter(option => option.value !== '')}
                          selectedValues={filterActualRating ? [filterActualRating] : []}
                          onApply={(values) => {
                            setFilterActualRating(values.length > 0 ? values[0] : '');
                            setPage(1);
                          }}
                          onSort={(direction) => {
                            const nextState = direction === 'ascending' ? 'ascending' : 
                                             direction === 'descending' ? 'descending' : 'default';
                            setSortActualRating(nextState);
                          }}
                          currentSortState={sortActualRating}
                          placeholder="Filter"
                          label="Actual Rating"
                          singleSelect={true}
                          showSort={true}
                        />
                      </div>
                    </th>
                  </>
                )}

                {filterColumn.includes('Calibration (Previous)') && projectPhase && projectPhase.Phase.Order >= 2 && (
                  <>
                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        <span>Score</span>
                        <ExcelFilter
                          options={[]} // No filter options for score
                          selectedValues={[]}
                          onApply={() => {}} // No filter functionality for score
                          onSort={(direction) => {
                            const nextState = direction === 'ascending' ? 'ascending' : 
                                             direction === 'descending' ? 'descending' : 'default';
                            setSortScoreLatestMinusOne(nextState);
                          }}
                          currentSortState={sortScoreLatestMinusOne}
                          placeholder="Sort"
                          label="Score"
                          showSort={true}
                        />
                      </div>
                    </th>
                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        <span>Rating</span>
                        <ExcelFilter
                          options={RATING_OPTIONS.filter(option => option.value !== '')}
                          selectedValues={filterRatingBefore ? [filterRatingBefore] : []}
                          onApply={(values) => {
                            setFilterRatingBefore(values.length > 0 ? values[0] : '');
                          }}
                          onSort={(direction) => {
                            const nextState = direction === 'ascending' ? 'ascending' : 
                                             direction === 'descending' ? 'descending' : 'default';
                            setSortRatingLatestMinusOne(nextState);
                          }}
                          currentSortState={sortRatingLatestMinusOne}
                          placeholder="Filter"
                          label="Previous Rating"
                          singleSelect={true}
                          showSort={true}
                        />
                      </div>
                    </th>
                  </>
                )}

                {filterColumn.includes('Calibration') && (
                  <>
                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        <span>Score</span>
                        <ExcelFilter
                          options={[]} // No filter options for score
                          selectedValues={[]}
                          onApply={() => {}} // No filter functionality for score
                          onSort={(direction) => {
                            const nextState = direction === 'ascending' ? 'ascending' : 
                                             direction === 'descending' ? 'descending' : 'default';
                            setSortScoreLatest(nextState);
                          }}
                          currentSortState={sortScoreLatest}
                          placeholder="Sort"
                          label="Score"
                          showSort={true}
                        />
                      </div>
                    </th>
                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                        <span>Rating</span>
                        <ExcelFilter
                          options={RATING_OPTIONS.filter(option => option.value !== '')}
                          selectedValues={filterRating ? [filterRating] : []}
                          onApply={(values) => {
                            setFilterRating(values.length > 0 ? values[0] : '');
                          }}
                          onSort={(direction) => {
                            const nextState = direction === 'ascending' ? 'ascending' : 
                                             direction === 'descending' ? 'descending' : 'default';
                            setSortRatingLatest(nextState);
                          }}
                          currentSortState={sortRatingLatest}
                          placeholder="Filter"
                          label="Current Rating"
                          singleSelect={true}
                          showSort={true}
                        />
                      </div>
                    </th>
                  </>
                )}
              </tr>
            </thead>

            <tbody>
              {calibratedUsers.map((user, index) => {
                const latestScore = user.CalibrationScores[user.CalibrationScores.length - 1];
                const previousCalibration = user.CalibrationScores[user.CalibrationScores.length + latestCalibration];
                const calibrationData = user.CalibrationScores.filter(obj => obj.ProjectPhaseID);
                
                // Check justification from both original data and current calibratedScore state
                const currentCalibratedData = calibratedScore[user.ID];
                
                // Check if justification is filled/saved from original data
                const hasJustificationFromOriginal =
                  (calibrationData.length > 1 && 
                   calibrationData[calibrationData.length - 2].JustificationType !== "default" && 
                   calibrationData[calibrationData.length - 2].FilledTopBottomMark) ||
                  (latestScore.JustificationType !== "default" && latestScore.FilledTopBottomMark) ||
                  (latestScore.JustificationType === "default" && latestScore.Comment !== "") ||
                  calibrationData[0]?.Comment !== "";
                
                // Check if justification is saved in current state (from recent saves)
                const hasJustificationFromState = currentCalibratedData && 
                  currentCalibratedData.JustificationType && 
                  ((currentCalibratedData.JustificationType !== "default" && currentCalibratedData.FilledTopBottomMark === true) ||
                   (currentCalibratedData.JustificationType === "default" && currentCalibratedData.Comment && currentCalibratedData.Comment.trim() !== ""));
                
                const hasJustification = hasJustificationFromOriginal || hasJustificationFromState;

                return (
                  <TableRow
                    key={user.ID}
                    user={user}
                    index={index}
                    calibratedScore={calibratedScore}
                    justificationIdNotFilled={justificationIdNotFilled}
                    usersRequiringJustification={usersRequiringJustification}
                    filterColumn={filterColumn}
                    previousRating={previousRating}
                    projectPhase={projectPhase}
                    previousCalibration={previousCalibration}
                    latestScore={latestScore}
                    hasJustification={hasJustification}
                    watch={watch}
                    SCORE_OPTIONS={SCORE_OPTIONS}
                    RATING_OPTIONS={RATING_OPTIONS}
                    handleScoreSelectChange={handleScoreSelectChange}
                    handleScoreInputChange={handleScoreInputChange}
                    handleScoreBlur={handleScoreInputBlur}
                    handleRatingChange={handleRatingChange}
                    handleShowJustificationModal={handleShowJustificationModal}
                    setDetailActualScore={setDetailActualScore}
                    setSpmoComment={setSpmoComment}
                    hanldeShowAdditionalInfoModal={handleShowAdditionalInfoModal}
                    isSavingScore={isSavingScore}
                    currentEditingUserId={currentEditingUserId}
                  />
                );
              })}
            </tbody>
          </table>

          {/* Pagination */}
          <PaginationComponent
            current={page}
            totalPages={totalPage}
            navigate={(newPage) => {
              changePage(
                newPage, calibratorID, params,
                filterUserName, filterGrade, filterSupervisorName, filterDivision,
                sortName, sortGrade, sortActualScore, sortActualRating,
                sortScoreLatest, sortRatingLatest,
                filterRating, latestCalibration + 1, sortScoreLatestMinusOne,
                sortRatingLatestMinusOne, filterRatingBefore, filterChangeScore, filterActualRating
              );
              setJustificationModalUserID(null);
            }}
          />
        </div>

        {/* Modals */}
        {renderJustificationModal}

        {userJustification && (
          <JustificationModalLatest
            show={showJustification}
            handleClose={() => setShowJustification(false)}
            user={userJustification}
            projectID={project.ID}
            calibratorID={calibratorID}
            justificationModalUserID={justificationModalUserID}
          />
        )}

        {/* Additional Info Modal */}
        {showAdditionalInfo && selectedAdditionalInfo && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1050
            }}
            onClick={() => setShowAdditionalInfo(false)}
          >
            <div 
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '24px',
                maxWidth: '600px',
                width: '90%',
                maxHeight: '80vh',
                overflow: 'auto',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <AiOutlineWarning fontSize={24} color='#FF9F43' style={{ marginRight: '12px' }} />
                <h5 style={{ margin: 0, fontWeight: '600' }}>Additional Information</h5>
              </div>
              
              <div style={{ marginBottom: '16px', paddingBottom: '16px', borderBottom: '1px solid #e0e0e0' }}>
                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                  <strong>Name:</strong> {selectedAdditionalInfo.name}
                </p>
                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                  <strong>NIK:</strong> {selectedAdditionalInfo.nik}
                </p>
                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                  <strong>Position:</strong> {selectedAdditionalInfo.position || '-'}
                </p>
                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                  <strong>Supervisor:</strong> {selectedAdditionalInfo.supervisor || '-'}
                </p>
              </div>
              
              <div style={{ 
                backgroundColor: '#fff9f0', 
                padding: '16px', 
                borderRadius: '6px',
                border: '1px solid #ffe0b2',
                marginBottom: '16px'
              }}>
                <p style={{ 
                  margin: 0, 
                  fontSize: '14px', 
                  lineHeight: '1.6',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word'
                }}>
                  {selectedAdditionalInfo.info}
                </p>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowAdditionalInfo(false)}
                  style={{
                    backgroundColor: '#02B4CC',
                    border: 'none',
                    padding: '8px 24px',
                    borderRadius: '5px'
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Tooltips */}
        <Tooltip id="tooltip-status" style={{ backgroundColor: "#efefef", color: "#222", width: "20rem" }}>
          <b>Calibration Status</b>
          <div className="mb-1">
            <Tag color={'yellow'}>Waiting</Tag>: Waiting calibration from the previous phase
          </div>
          <div className="mb-1">
            <Tag color={'blue'}>Calibrate</Tag>: You can start to calibrate user
          </div>
          <div className="mb-1">
            <Tag color={'green'}>Complete</Tag>: Calibration already submitted
          </div>
        </Tooltip>

        <Tooltip id="tooltip-spmo-status" style={{ backgroundColor: "#efefef", color: "#222", width: "20rem" }}>
          <b>SPMO Status</b>
          <hr />
          {spmoComment && <><b>SPMO Comment:</b> {spmoComment}</>}
        </Tooltip>

        <Tooltip id="tooltip-actual-score" style={{ backgroundColor: "#efefef", color: "#222", width: "10rem" }}>
          <b>Score Detail</b>
          <div className="mb-1">PTT: {detailActualScore.PTTScore ? formatScore(detailActualScore.PTTScore) : "N/A"}</div>
          <div className="mb-1">PAT: {detailActualScore.PATScore ? formatScore(detailActualScore.PATScore) : "N/A"}</div>
          <div className="mb-1">360: {detailActualScore.Score360 ? formatScore(detailActualScore.Score360) : "N/A"}</div>
        </Tooltip>

        <Tooltip id="tooltip-download-report" style={{ backgroundColor: "#efefef", color: "#222", width: "15rem" }}>
          <b>Download Calibration Report</b>
          <div>Download the complete calibration report as an Excel file</div>
        </Tooltip>

        <Tooltip id="tooltip-reset-filters" style={{ backgroundColor: "#efefef", color: "#222", width: "12rem" }}>
          <b>Reset All Filters</b>
          <div>Clear all active filters and sorting to show all data</div>
        </Tooltip>
      </div>
    </Suspense>
  );
};

export default CalibrationTableRefactored;
